import React, { useState, useEffect, useRef } from 'react';
import '../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/CheckboxList.css';
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../Components/BasicElements/BackModal';
import ConfirmModal from '../../Components/BasicElements/ConfirmModal';
import { useCookies } from "react-cookie";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const HolidayUpdate = (props) => {
	//#region React Hooks
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [hasChanges, setHasChanges] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [editData, setEditData] = useState([]);
	const [inputError, setInputError] = useState([]);

	useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				HOLIDAY_ID: props.editData.HOLIDAY_ID === null ? "" : props.editData.HOLIDAY_ID,
				HOLIDAY_NAME: props.editData.HOLIDAY_NAME === null ? "" : props.editData.HOLIDAY_NAME,
				HOLIDAY_DATE: props.editData.HOLIDAY_DATE === null ? "" : props.editData.HOLIDAY_DATE,
			})
		}
	}, [props.editData]);
	//#endregion

	//#region Save Edit
	function saveEditHoliday() {
		let functionName = "";
		try {
			functionName = saveEditHoliday.name;
			setLoading(true, "Updating holiday, Please wait....");
			const data = {
				HOLIDAY_ID: editData.HOLIDAY_ID,
				HOLIDAY_NAME: editData.HOLIDAY_NAME,
				HOLIDAY_DATE: editData.HOLIDAY_DATE,
				UPDATE_ID: userId,
				FROM_SOURCE: {SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.post("api/holiday/HolidayUpdate", data, { timeout: 10000})
				.then((response) => {
					if (response.data.DUPLICATE_LEAVE === true) {
						toast.error("User applied leave on " + common.c_Dis_DateTime(response.data.HOLIDAY_DATE).val_datetime.toLocaleDateString('en-GB'));
					}
					else if (response.data.DUPLICATE_HOLIDAY_NAME === true) {
						toast.error("Holiday Name " + response.data.HOLIDAY_NAME + " on " + common.c_Dis_DateTime(response.data.HOLIDAY_DATE).val_datetime.toLocaleDateString('en-GB') + " already exist. Please use a new name" );
					}
					else {
						toast.success("Holiday is successfully Updated.");
						props.onReload();
					}
				})
				.catch((err) => {
					toast.error("Failed to update holiday. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
		} catch (err) {
			toast.error("Failed to update holiday. Please try again.....(receive)");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}

		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
	};

	//#region Event handle
	const hideModal = () => {
		setEditData([]);
		setInputError([]);
		props.onHide();
	};

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		if (Object.values(inputError).filter(v => v !== "").length === 0){
			setShowConfirmModal(true);
		}
	};

	const handleConfirmModal = () => {
		saveEditHoliday();
		setShowConfirmModal(false); // Hide confirm modal
		hideModal();
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide confirm modal on cancel
	};
	//#endregion

	return (
		<>
		<Modal show={props.showHide} onHide={hideModal} centered size="mg">
			<Modal.Header>
				<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
					<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit</Modal.Title>
				</div>
			</Modal.Header>

			<Modal.Body>
				<Comp.Input
					id="HOLIDAY_NAME"
					label="Holiday Name*"
					name="Holiday Name"
					type="text"
					className="form-control"
					errorMessage={inputError.HOLIDAY_NAME}
					value={editData.HOLIDAY_NAME}
					onChange={inputRequiredHandler}
				/>

				<Comp.Input
					id="HOLIDAY_DATE"
					label="Holiday Date*"
					name="Holiday Date"
					type="date"
					className="form-control"
					errorMessage={inputError.HOLIDAY_DATE}
					value={editData.HOLIDAY_DATE ? editData.HOLIDAY_DATE.slice(0, 10) : ""}
					onChange={inputRequiredHandler}
				/>
			</Modal.Body>

			<Modal.Footer>
				<div className="onright-container">
					<Comp.Button
						id="btnCancel"
						type="cancel"
						onClick={handleBack}
					>
						<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
					</Comp.Button>
						
					<Comp.Button id="btnSave" onClick={handleConfirm}>
						<FontAwesomeIcon icon={faCheck} />&nbsp; Save
					</Comp.Button>
				</div>
			</Modal.Footer>
		</Modal>

		{/* Confirmation Modal */}
		<BackModal
			show={showBackModal}
			onHide={handleConfirmBackCancel}
			onConfirm={handleConfirmBack}
			prop="Confirm Navigation"
		>
			Are you sure you want to go back? Your changes may be lost.
		</BackModal>

		<ConfirmModal
			show={showConfirmModal}
			onHide={handleConfirmModalClose}
			onConfirm={handleConfirmModal}
			prop="Confirm to save"
		>
			Are you sure you want to update holiday?
		</ConfirmModal>
				
		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />
		</>
	);
};

export default HolidayUpdate;
